:
<template>
    <div>
        <div class="flex flex-wrap my-3">
            <div class="w-full lg:w-1/6"></div>
            <div class="w-full lg:w-8/12 text-center">
                <h1 class="text-3xl capitalize">
                    Caja para
                    {{ selectedMerchant.merchantType | merchantInfo("type") }}
                    <strong class="text-theme-primary">
                        {{ selectedMerchant.name }}
                    </strong>
                </h1>
            </div>
            <div class="w-full lg:w-2/12 flex justify-center items-center">
                <custom-switch
                    v-if="$ability.hasPermission('merchant:UpdateBox')"
                    v-model="enabledUpdate"
                    class="mr-1"
                >
                    <span class="text-theme-inverse">🖊</span>
                </custom-switch>

                <app-button
                    icon
                    circle
                    color="brand-purple"
                    @click="getBoxMerchantComponent"
                >
                    <reload-icon class="h-5 w-5 text-white" />
                </app-button>
            </div>
        </div>

        <div class="flex mt-4 mx-3">
            En esta sección, puedes ver el balance de dinero en la caja. Además,
            tienes la capacidad de actualizar el balance de dinero de la caja.
        </div>
        <money-config-manage v-model="moneyConfig" :enabled="enabledUpdate" />
        <div v-if="enabledUpdate" class="w-full flex justify-center mt-4">
            <app-button @click="updateBoxMerchantComponent">
                Actualizar caja
            </app-button>
            <app-button danger @click="resetBox"> Reiniciar caja </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { EMPTY_MONEY_CONFIG } from "@/common/lib/money";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import MoneyConfigManage from "@/components/utils/MoneyConfigManage.vue";

export default {
    name: "BoxDetails",
    components: {
        MoneyConfigManage,
        ReloadIcon
    },
    data: () => ({
        moneyConfig: {},
        isLoading: false,
        enabledUpdate: false
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("merchant:GetBox", "/app", true)))
            return;
        await this.getBoxMerchantComponent();
    },
    methods: {
        ...mapActions("merchants", ["getBoxMerchant", "updateBoxMerchant"]),
        async getBoxMerchantComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                const moneyConfig = await this.getBoxMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType
                });
                this.moneyConfig = moneyConfig;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async resetBox() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Vas a reiniciar la caja ?",
                text: "Si el balance de dinero en la caja quedará en 0. Estas seguro de la operación ?",
                icon: "info",
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: "Si",
                cancelButtonText: "No",
                confirmButtonColor: "#02913f",
                cancelButtonColor: "#d33ddd",
                allowOutsideClick: false
            });
            if (!dialogResult.isConfirmed) {
                return;
            }
            this.moneyConfig = EMPTY_MONEY_CONFIG;
            await this.updateBoxMerchantComponent();
        },
        async updateBoxMerchantComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateBoxMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType,
                    moneyConfig: this.moneyConfig
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
